import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPickupEditOptionsModal } from "../../../reducers/ownApp";
import { updatePickupModal } from "../../../reducers/matrixProfile/thunkActions";
import {
  pickupEditOptionsModalOpenSelector,
  pickupEditOptionsModalOptionsSelector,
} from "../../../reducers/ownApp/selectors";

import { Modal } from "../Modal";
import { PickupEditOptionsModalContent } from "./PickupEditOptionsModalContent";
import { PickupEditOptionsModalActions } from "./PickupEditOptionsModalActions";

const PickupEditOptionsModal = () => {
  const dispatch = useDispatch();
  const open = useSelector(pickupEditOptionsModalOpenSelector);
  const options = useSelector(pickupEditOptionsModalOptionsSelector);
  const [selectedOption, setSelectedOption] = useState();

  useEffect(() => {
    options?.length && setSelectedOption(options[0]);
  }, [options]);

  const closeClick = () => {
    dispatch(setPickupEditOptionsModal({ open: false }));
  };

  const confirmClick = () => {
    dispatch(setPickupEditOptionsModal({ open: false }));
    dispatch(updatePickupModal(selectedOption));
  };

  if (!open) return null;
  return (
    <>
      <Modal
        maxWidth={"xs"}
        open={open}
        onClose={closeClick}
        title={"Warning"}
        content={
          <PickupEditOptionsModalContent
            options={options}
            selectedOption={selectedOption}
            onOptionChange={(option) => {
              setSelectedOption(option);
            }}
          />
        }
        actions={
          <PickupEditOptionsModalActions
            onCancel={closeClick}
            onContinue={confirmClick}
          />
        }
        minWidth={500}
      />
    </>
  );
};

export default PickupEditOptionsModal;
